import React, { useState, useEffect, useRef } from 'react';
import MediaPlayer from './mediaplayer';

const MediaPlayerController = () => {
    const [mediaPlayers, setMediaPlayers] = useState([]);
    const [activeTitle, setTitle] = useState("Waiting for long form content...");

    const appInfoToggleRef = useRef(null);
    const appInfoRef = useRef(null);

    const trayToggleRef = useRef(null);

    const volRef = useRef(null);
    const clockUIRef = useRef(null);

    const sliderRef = useRef(null);
    const sliderBlockerRef = useRef(null);
    const shadowRef = useRef(null);

    const activeLongformRef = useRef({ vol: 0 });


    useEffect(() => {
        fetchMedia();

        let xScrollRef = document.getElementById("longform-audio-container");

        xScrollRef.addEventListener('wheel', (e) => {
            e.preventDefault();
            xScrollRef.scrollBy({ left: e.deltaY < 0 ? -100 : 100 });
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchMedia = async () => {
        try {
            const response = await fetch("/shortdb.json");
            const data = await response.json();
            data.forEach(element => {
                addMediaPlayer({ vol: 1, active: false, isActive: false, title: element.title, src: element.src, type: "loop" });
            });
        } catch (error) {
            console.error("Error fetching short form media.", error);
        }
        try {
            const response = await fetch("/longdb.json");
            const data = await response.json();
            data.forEach(element => {
                addMediaPlayer({ vol: 1, active: false, isActive: false, title: element.title, src: element.src, type: "long" });
            });
        } catch (error) {
            console.error("Error fetching long form media.", error);
        }
    };

    const addMediaPlayer = ({ vol, active, isActive, title, src, type }) => {
        setMediaPlayers(prevState => {
            const newId = `player${prevState.length}`;
            return [...prevState, { id: newId, vol, active, isActive, title, src, type }];
        });
    };

    const toggleActive = (player) => {
        setMediaPlayers(prevState => {
            return prevState.map(prevPlayer => {
                if (prevPlayer.id === player.id) {
                    if (prevPlayer.active) {
                        toggleActivityDisplay(player.id, false);
                    } else {
                        if (player.type === "long") {
                            activeLongformRef.current = player;

                            prevState.forEach(otherPlayer => {
                                if (otherPlayer.type === "long" && otherPlayer.id !== player.id) {
                                    toggleActivityDisplay(otherPlayer.id, false);
                                }
                            });

                            setTimeout(() => {
                                toggleActivityDisplay(player.id, true);
                            }, 0);
                        }
                        toggleActivityDisplay(player.id, true);
                    }
                    return { ...prevPlayer, active: !prevPlayer.active, isActive: !prevPlayer.isActive };
                } else if (player.type === "long" && prevPlayer.type === "long") {
                    return { ...prevPlayer, active: false, isActive: false };
                }
                return prevPlayer;
            });
        });
    };

    const changeVolume = (id, vol) => {
        setMediaPlayers(prevState => {
            return prevState.map(player => {
                if (player.id === id) {
                    if (player.id === activeLongformRef.current.id) {
                        activeLongformRef.current.vol = vol;
                    }
                    return { ...player, vol };
                }
                return player;
            });
        });
    };

    const pauseAllPlayers = () => {
        shadowRef.current.classList.toggle("active");

        setMediaPlayers(prevState => {
            return prevState.map(player => {
                if (player.isActive === true) {
                    player.active = !player.active;
                }
                return player;
            });
        });
    };

    const buildMediaPlayers = (type) => {
        return mediaPlayers.map(player => {
            if (player.type === type && type === "loop") {
                return (
                    <div key={player.id} className="looping-audio-button">
                        <input
                            aria-label={`${player.title} volume slider`}
                            type="range"
                            min="0"
                            max="1"
                            step="0.025"
                            value={player.vol}
                            onChange={(e) => { changeVolume(player.id, e.target.value); }}
                        />
                        <button id={`button-${player.id}`} onClick={() => { toggleActive(player); }}>
                            <p>{player.title}</p>
                        </button>
                        <MediaPlayer
                            vol={player.vol}
                            active={player.active}
                            isActive={player.isActive}
                            id={`player-${player.id}`}
                            title={player.title}
                            src={player.src}
                            loop={true}
                        />
                    </div>
                );
            } else if (player.type === type && type === "long") {
                return (
                    <div key={player.id} className="longform-audio-button">
                        <button id={`button-${player.id}`} onClick={() => { toggleActive(player); setTitle(player.title); }}>
                            <p className="audio-title">{player.title}</p>
                            <MediaPlayer
                                vol={player.vol}
                                active={player.active}
                                isActive={player.isActive}
                                id={`player-${player.id}`}
                                title={player.title}
                                src={player.src}
                                loop={false}
                            />
                        </button>
                    </div>
                );
            } else {
                return null;
            }
        });
    };

    const toggleActivityDisplay = (id, isActive) => {
        const button = document.getElementById(`button-${id}`);
        if (button) {
            if (isActive) {
                button.classList.add("active");
            } else {
                button.classList.remove("active");
            }
        }
    };

    const toggleAppInfo = () => {
        if (appInfoRef.current) {
            appInfoRef.current.classList.toggle("visible");
            appInfoRef.current.focus();
        }
        if (appInfoToggleRef.current) {
            appInfoToggleRef.current.classList.toggle("active");
        }
    };

    const toggleVolumeTray = () => {
        if (volRef.current) {
            volRef.current.classList.toggle("visible");
            trayToggleRef.current.classList.toggle("hide-from-volume");
        }
    };

    const toggleSlideOut = () => {
        if (sliderRef.current) {
            sliderRef.current.classList.toggle("visible");
            sliderBlockerRef.current.classList.toggle("visible");
        }
    };

    const slideOutContainer = () => {
        return (
            <>
                <div ref={clockUIRef} id="alarm-clock-container">test</div>
                <div ref={sliderBlockerRef} id="slide-out-blocker"></div>
                <div ref={sliderRef} id="slide-out-container">
                    <button className="toggler" ref={trayToggleRef} onClick={() => { toggleSlideOut(); }}>
                        <span className="speaker-line"></span>
                        <span className="line"></span>
                        <span className="line"></span>
                        <span className="line"></span>
                        <span className="line"></span>
                        <span className="line"></span>
                        <span className="line"></span>
                        <span className="line"></span>
                        <span className="line"></span>
                        <span className="line"></span>
                        <span className="line"></span>
                        <span className="line"></span>
                        <span className="line"></span>
                    </button>

                    <div id="alt-controls">
                        <div id="lf-vol-container" ref={volRef}>
                            {(activeLongformRef.current.id === null || activeLongformRef.current.id === undefined) && (
                                <div id="lf-vol-blocker">Select some longform audio!</div>
                            )}
                            <input id="lf-vol-slider"
                                type="range"
                                min="0"
                                max="1"
                                step="0.025"
                                value={activeLongformRef.current.vol}
                                onChange={(e) => { changeVolume(activeLongformRef.current.id, e.target.value); }}
                            />
                        </div>
                        <div id="lf-controls">
                            <button onClick={() => { toggleVolumeTray(); }}>Vol</button>
                            <button onClick={() => { pauseAllPlayers(); }}>||></button>
                        </div>
                    </div>
                    <div id="longform-audio-container">
                        <div ref={shadowRef} id="longform-container-shadow">
                            <span className="line"></span>
                            <span className="line"></span>
                            <span className="line"></span>
                            <span className="line"></span>
                            <span className="line"></span>
                            <span className="line"></span>
                            <span className="line"></span>
                            <span className="line"></span>
                            <span className="line"></span>
                            <span className="line"></span>
                            <span className="line"></span>
                            <span className="line"></span>
                            <span className="line"></span>
                            <span className="line"></span>
                            <span id="active-title-readout">
                                You've currently paused: <p>{activeTitle}</p>
                            </span>
                        </div>
                        {buildMediaPlayers("long")}
                    </div>
                </div>
            </>
        );
    };

    return (
        <>
            <div id="application-information" aria-label="Application information" ref={appInfoRef}>
                <p style={{ position: "absolute", top: "1rem",  color: "gold", textAlign: "center", fontWeight: "bolder" }}>v1.0</p>
                <br />
                <p style={{ textAlign: "center", textDecoration: "underline" }}>Known "bugs"</p>
                <ul>
                <li style={{ textAlign: "center"}}>There is no native support for controlling audio level across multiple sources for iOS devices.</li>
                </ul>
                <br />
                <p style={{ textAlign: "center" }}>If you experience buffering issues, toggling the sound or reloading the application may resolve them.</p>
                <br />
                <p style={{ textAlign: "center" }}>Suggestions for audio content?</p>
                <a href="https://www.kchat.dev/contact">Contact Me!</a>
            </div>
            <div id="site-title">
                <span className="gradient">AudiOverlay</span>
                <button
                    aria-label="Toggle application information pop-out"
                    aria-pressed="false"
                    aria-haspopup="dialog"

                    ref={appInfoToggleRef} onClick={() => { toggleAppInfo() }}>
                    !
                </button>
            </div>
            <img id="backdrop" src="./images/moon.png" alt="Backdrop" />
            <div className="looping-audio-container">
                {buildMediaPlayers("loop")}
            </div>
            {slideOutContainer()}
        </>
    );
};

export default MediaPlayerController;
